import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class TableHeaderService {
  public onClick: EventEmitter<string> = new EventEmitter();
  constructor() {}
}
